<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('base.dc.dcName')" prop="supplierNameShort">
                  <el-input v-model="queryCondition.supplierNameShort" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('base.dc.dcNo')" prop="supplierCode">
                  <el-input v-model.trim="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="物流服务商编号" prop="carrierCode">
                  <el-input v-model.trim="queryCondition.carrierCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="物流服务商名称" prop="carrierNmae">
                  <el-input v-model="queryCondition.carrierNmae" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('settlementUnit.ApprovalStatus')" prop="auditStatus">
                    <ic-select clearable table="TM_SUPPLIER" field="STATUS" v-model="queryCondition.auditStatus" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建日期(从)" prop="createDate">
                    <el-date-picker v-model="queryCondition.createDate" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptionsStart" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建日期(至)" prop="updateDate">
                    <el-date-picker v-model="queryCondition.updateDate" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptionsEnd" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">{{ $t('common.search') }}</el-button>
          <el-button size="mini" @click="restQueryForm()" type="primary">{{ $t('common.reset') }}</el-button>
          <span class="arrowDown" @click="isShow = !isShow">{{ isShow ? '收缩' : '展开' }}<i :class="isShow ? 'el-icon-arrow-up iconBtn' : 'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <!--这个新增是供应商可以操作的-->
      <!-- <el-button size="mini" class="btn" v-if="emplFlag === 'S'" type="primary" @click="add()" v-acl="DcSave">{{$t('common.newBuilt') }}</el-button> -->
      <el-button size="mini" class="btn" type="primary" @click="mdmClick" v-acl="DCMaterialIssueMDM">数据同步MDM</el-button>
      <el-button size="mini" class="btn" type="primary" @click="download" v-acl="DataListDownload">{{$t('common.download') }}</el-button>
    </div>
    <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='420'>
      <el-table-column show-overflow-tooltip prop="supplierNameShort" :label="$t('DC.supplierName')">
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row)">{{ scope.row.supplierNameShort }}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('base.dc.dcNo')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="carrierCode" label="物流服务商编号"></el-table-column>
      <el-table-column show-overflow-tooltip prop="carrierNmae" label="物流服务商名称"></el-table-column>
      <el-table-column show-overflow-tooltip prop="dctypeI18n" label="DC Type"></el-table-column>
      <el-table-column show-overflow-tooltip prop="statusI18n" :label="$t('base.dc.dcStatus')"></el-table-column><!-- DC状态 -->
      <el-table-column show-overflow-tooltip prop="auditStatusI18n" :label="$t('settlementUnit.ApprovalStatus')">
        <template slot-scope="scope">{{ scope.row.auditStatus | ic("TM_SUPPLIER", "STATUS") }}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="supplierNameShort" label="操作">
        <template slot-scope="scope">
          <div class="a-link" @click="editRow(scope.row)">修改物流服务商</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body width="85%" title="FPA-Permanent" :close-on-click-modal="false" @close="onClose">
      <fpa ref="fpaMdm"></fpa>
    </el-dialog>

    <el-dialog class="group_dialog" :visible.sync="dialogVisible2" title="修改物流服务商" width="50%" :close-on-click-modal="false">
      <el-form :model="supplierResourceForm" class="plantCodeForm" ref="plantCodeForm" label-width="130px" label-position="right" :rules="rulesSupResource">

        <el-table :data="supResourceTableList" ref="supResourceTableList" row-key="tmSupplierId" border highlight-current-row style="margin-top:20px;">
          <el-table-column type="selection"></el-table-column>
          <!--供应商编号/邀请码-->
          <el-table-column prop="supplierCode" :label="$t('ssrManage.invitationCode')"></el-table-column>
          <!--供应商名称-->
          <el-table-column prop="supplierName" :label="$t('ssrManage.supplierName')"></el-table-column>
          <!--供应商英文名称-->
          <el-table-column prop="supplierNameEn" :label="$t('ssrManage.supplierEnName')"></el-table-column>
        </el-table>

        <el-row type="flex" justify="center" style="margin-top:15px">
          <el-button size="mini" @click="editSupResource" type="primary">修改</el-button>
          <el-button size="mini" @click="cancelSupResource" type="primary">取消</el-button>
        </el-row>
      </el-form>
    </el-dialog>

  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import DCApi from "@/api/DC/DC";
import fpa from './dialog.vue'
import supplier from "@/api/supplier/supplier";

export default {
  components: { IcSelect, fpa },
  name: "",

  data() {
    return {
      rulesSupResource: {
        plantCode: [
          { required: true, message: '请输入工厂编码', trigger: ["blur"] }
        ]
      },
      getSupRow: {},
      supResourceTableList: [],
      supplierResourceForm: {},
      dialogVisible2: false,
      dialogVisible: false,
      isShow: false,//控制查询列表收缩展开
      queryCondition: {
        supplierCode: '',
        supplierName: '',
        carrierCode: '',
        carrierNmae: '',
        auditStatus: '',
        pageNum: 1,
        pageSize: 15,
        createDate: '',
        updateDate: '',
      },
      tableList: [],
      emplFlag: null,
      totalCount: 0,
      pickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.updateDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.createDate;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    };
  },
  created() {
    this.queryData();
    this.getUserType()
  },
  methods: {
    mdmClick() {
      this.dialogVisible = true
    },
    onClose() {
      // console.log('2222', this.$refs.fpaMdm);
      this.$refs.fpaMdm.issueList = []
      this.$refs.fpaMdm.selectRadio = ''
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      DCApi.getDCList(this.queryCondition).then(res => {
        this.tableList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    restQueryForm() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition = {
        supplierCode: '',
        supplierName: '',
        carrierCode: '',
        carrierNmae: '',
        auditStatus: '',
        pageNum: 1,
        pageSize: 15,
        createDate: '',
        updateDate: '',
      }
      this.queryData();
    },
    editRow(row) {
      let params = {
        auditStatus: "PASS",
        groupType: "CARRIER",
        pageSize: -1,
      }
      this.getSupRow = row
      supplier.resourceList(params).then(res => {
        this.supResourceTableList = res.resultData;
        this.dialogVisible2 = true
        // this.totalCount = res.totalCount;
      });
    },
    // add() {
    //   this.$router.push({
    //     path: `/DCDetail`,
    //   });
    // },
    toDetail(row) {
      this.$router.push({
        path: `/DCDetail/view`,
        query: { id: row.tmSupplierId }
      });
    },
    download() {
      DCApi.exportList(this.queryCondition);
    },
    getUserType() {
      //用户所属系统(SUP供应商)
      const emplFlag = localStorage.getItem("ms_emplFlag");
      console.log(emplFlag)
      //供应商用户
      if (emplFlag === 'SUP') {
        this.emplFlag = 'S';
      } else {
        let permission = JSON.parse(localStorage.getItem("ms_Permission"));
        for (let i = 0, len = permission.length; i < len; i++) {
          if (permission[i] == 'IS_MDM') {
            this.emplFlag = 'M';
          }
        }
      }
    },
    editSupResource() {

      let val = this.$refs.supResourceTableList.selection
      if (val.length > 1) {
        this.$message.error("仅可选择一条数据修改")
      } else {
        let params = {
          tmSupplierId: this.getSupRow.tmSupplierId,
          supperSupplierId: val[0].tmSupplierId,
        }
        DCApi.editBelongsTo(params).then((res) => {
          if (res.code == 200) {
            this.$message.success('修改成功')
            this.dialogVisible2 = false
            this.queryData()
          } else {
            this.$message.error(res.msg)
          }
          console.log("rrrrrrrrrrr", res)
        })
      }
    },
    cancelSupResource() {
      this.dialogVisible2 = false
    }
  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
.el-table {
  margin-top: 10px;
}

.el-select,
.el-date-editor {
  width: 100%;
}
</style>
<style lang="scss">
.DCList .createDateArr .el-form-item__content {
  display: flex;
}
</style>
